(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/info.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/info.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.Info = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.info(data);
    }
  });
})(Backbone, _, svs);

 })(window);